// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@bg/XDL/types";
import { ButtonProps } from "@insite/mobius/Button";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import resolveColor from "@insite/mobius/utilities/resolveColor";

import { css } from "styled-components";

export default {
    defaultProps: {
        buttonProps: {
            sizeVariant: "small",
            size: 24,
            hoverMode: undefined,
            buttonType: "solid",
            typographyProps: { size: 14, weight: 400, lineHeight: "18px" },
            css: css<ButtonProps>`
                &:not(:disabled):hover {
                    cursor: pointer;
                }
                & {
                    width: auto;
                    border: none;
                    padding: 0;
                    background: transparent;
                }
                border-radius: 0px;
                margin: 0;
                &:disabled {
                    opacity: 0.5;
                }
            `,
        },
        currentPageButtonVariant: "secondary",
        cssOverrides: {
            currentButton: css`
                ${TypographyStyle} {
                    font-weight: 700;
                    font-size: 14px;
                }
            `,
            ellipsis: css`
                cursor: pointer;
                font-size: 16px;
                letter-spacing: 2px;
            `,
        },
        selectProps: {
            cssOverrides: {
                formField: css`
                    width: auto;
                    max-width: 60px;
                `,
                formInputWrapper: css`
                    width: 55px;
                `,
                inputSelect: css`
                    ${getProp("theme.formField.defaultProps.cssOverrides.inputSelect")}
                    padding-right: 10px !important;
                `,
            },
            labelProps: {
                css: css`
                    display: none;
                `,
            },
        },
    },
} as xBaseTheme["pagination"];
